<template>
  <div class="home-section margin-top_24">
    <div class="section-title">
      <span class="text">平台服务</span>
    </div>
    <div class="content">
      <div v-for="(item, index) of navList" :key="index" class="item" @click="turnTo(item)">
        <img :src="item.icon" :alt="item.label" class="icon" />
        <span class="label">{{ item.label }}</span>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: 'HomeSection3',

  data() {
    return {
      navList: [
        {
          label: '学习平台',
          icon: require('@/assets/server-icon/icon_01.png'),
          isExternal: true,
          path: 'training'
        },
        {
          label: '合作机构查询',
          icon: require('@/assets/server-icon/icon_02.png'),
          path: '/institutions'
        },
        {
          label: '证书查询',
          icon: require('@/assets/server-icon/icon_03.png'),
          path: '/certificate'
        },
        {
          label: '网络视听人才推荐',
          icon: require('@/assets/server-icon/icon_04.png'),
          path: '/publicTemp'
        },
        {
          label: '职业技能等级认定',
          icon: require('@/assets/server-icon/icon_05.png'),
          path: '/talentService',
          query: { id: 5 }
        },
        {
          label: '讲师资质申请',
          icon: require('@/assets/server-icon/icon_06.png'),
          path: '/publicTemp'
        },
        {
          label: '职业技能水平评价',
          icon: require('@/assets/server-icon/icon_07.png'),
          path: '/publicTemp'
        },
        {
          label: '退役军人培训',
          icon: require('@/assets/server-icon/icon_08.png'),
          path: '/publicTemp'
        },
        // {
        //   label: '退役军人培训',
        //   icon: require('@/assets/server-icon/icon_08.png'),
        //   path: '/veteran'
        // },
        {
          label: '实训直播基地',
          icon: require('@/assets/server-icon/icon_10.png'),
          path: '/publicTemp'
        },
        // {
        //   label: '实训直播基地',
        //   icon: require('@/assets/server-icon/icon_10.png'),
        //   path: '/publicInformationList',
        //   query: { classifyId: 11 }
        // },
        {
          label: '优秀案例展示',
          icon: require('@/assets/server-icon/icon_09.png'),
          path: '/publicInformationList',
          query: { classifyId: 9 }
        }
      ]
    }
  },
  methods: {
    turnTo({ path, query, isExternal }) {
      if (!path) {
        return
      }
      if (isExternal) {
        switch (path) {
          case 'training':
            if (window.location.href.indexOf('tvpc') > -1) {
              window.open(window.location.href.split('tvpc').join('tvweb'))
            } else {
              window.open('https://training.nrtatalent.cn')
            }
            break
        }
      } else {
        this.$router.push({ path, query })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.home-section {
  box-sizing: border-box;
  padding: 24px;
  background: linear-gradient(180deg, #DFEDFF 0%, #FFFFFF 100%, #FFFFFF 100%);
  .content {
    width: auto;
    margin: 0 -12px;
    padding-top: 32px;
    .item {
      display: inline-flex;
      width: 230px;
      height: 56px;
      margin: 0 12px;
      box-sizing: border-box;
      background: linear-gradient(180deg, #FFFFFF 0%, #ECEDEC 100%);
      border-radius: 8px;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      transition: all ease-in 0.15s;
      .icon {
        vertical-align: middle;
        width: 20px;
        height: 20px;
        margin-right: 6px;
      }
      .label {
        vertical-align: middle;
        font-weight: 600;
        line-height: 22px;
        font-size: 16px;
        color: #0861D5;
      }
      &:nth-child(n+6) {
        margin-top: 32px;
      }
      &:hover {
        background: linear-gradient(180deg, #FFFFFF 0%, #FFFFFF 100%);
        border: 1px solid #0861D5;
      }
    }
  }
}
</style>
